<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-05 10:34:51
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-22 11:51:41
 * @FilePath: \website\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <router-view />
</template> 

<script setup>
document.documentElement.setAttribute('theme-mode', 'dark');
// 检测是否为移动设备的函数
function isMobileDevice() {
    return /Mobi/.test(navigator.userAgent);  // 检查用户代理中是否包含 Mobi 关键字
}
// 根据设备类型设置视口
function setViewport() {
    var viewportMeta = document.querySelector('meta[name="viewport"]');
    if (isMobileDevice()) {
        // 移动端设备，禁止用户缩放
        viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    } else {
        // 桌面端，允许用户缩放
        viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    }
}

// 页面加载时设置视口
window.onload = function() {
    setViewport();
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}

* {
  margin: 0;
  padding: 0;
  /* scrollbar-color: #5F5F5F #181818;
  scrollbar-width: thin */
}

*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #5F5F5F;
}

*::-webkit-scrollbar-track {
  border-radius: 4px;
  background: #181818;
}


</style>
